
<template>
    <div class="card">
      <div class="card-content">
        <div class="row valign-wrapper">
          <div class="col l8 white-text">
            <span class="card-title"><strong>Votre site internet commence à dater ?</strong></span>
            <p>
              Un site internet obsolète n'est <strong>pas efficace</strong>.
              Il vous <strong>coûte de l'argent</strong> et ne vous rapporte rien en retour.
              Pire, il renvoie une <strong>image négative</strong> de votre activité et peut même faire <strong>fuir des clients</strong> potentiels !
            </p>
            <br>
            <span class="card-title"><strong>Votre entreprise ne possède pas de site internet ?</strong></span>
            <p>
              Nous vivons à l'<strong>époque du tout Digital</strong>,
              et même si votre activité s'est toujours bien portée sans site internet,
              cela risque d'être de moins en moins le cas dans le <strong>futur</strong>.
              Quand bien même vous avez la chance d'être dans un secteur à l'abri de la <strong>Digitalisation</strong>,
              posséder un site internet peut tout de même vous apporter beaucoup !
            </p>
          </div>
          <div class="col l4 center hide-on-med-and-down" data-aos="flip-left">
            <i class="material-icons very-large white-text">healing</i>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import content from '../content/fr.js'

export default {
  name: 'sitesection',

  data () {
    return {
      content: content
    }
  }
}
</script>

<style scoped>
strong {
    font-weight: bolder;
}
.very-large {
  font-size: 12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Sitesectionoldsite.vue